import React from "react";
import "../styles/WhyUsContenidoAds.scss";

const WhyUsContenidoAds = () => {
  return (
    <section className="ovit-why2" id="whyUs">
      <div className="ovit-why2__bg" aria-hidden="true">
        <div className="ovit-why2__grid" />
        <div className="ovit-why2__glow ovit-why2__glow--1" />
        <div className="ovit-why2__glow ovit-why2__glow--2" />
      </div>

      <div className="ovit-why2__container">
        <header className="ovit-why2__header">
          <h2 className="ovit-why2__title">
            ¿Por qué <span>no</span> estás vendiendo?
          </h2>
          <p className="ovit-why2__subtitle">
            No es falta de “suerte”. Normalmente faltan 3 cosas: mensaje claro, tráfico y seguimiento.
          </p>
        </header>

        <div className="ovit-why2__gridCards">
          <article className="ovit-why2__card">
            <div className="ovit-why2__icon">⚠️</div>
            <h3 className="ovit-why2__cardTitle">Publicas, pero no conviertes</h3>
            <p className="ovit-why2__cardText">
              Sin estructura, tus publicaciones solo “se ven bonitas”. Nosotros diseñamos contenido
              para generar confianza y acción.
            </p>
            <ul className="ovit-why2__list">
              <li>Hook + beneficio</li>
              <li>CTA correcto</li>
            </ul>
          </article>

          <article className="ovit-why2__card">
            <div className="ovit-why2__icon">🎯</div>
            <h3 className="ovit-why2__cardTitle">Campañas sin estrategia</h3>
            <p className="ovit-why2__cardText">
              Pagar anuncios sin segmentación y optimización es tirar dinero. Ajustamos anuncios,
              audiencias y creativos para mejorar el rendimiento.
            </p>
            <ul className="ovit-why2__list">
              <li>Segmentación real</li>
              <li>Creativos que venden</li>
            </ul>
          </article>
        </div>

        <div className="ovit-why2__bridge">
          <div className="ovit-why2__bridgeCard">
            <div className="ovit-why2__bridgeTitle">
              La solución es simple: <span>Contenido + Campañas</span>
            </div>
            <div className="ovit-why2__bridgeText">
              Creamos el contenido, lanzamos campañas, optimizamos y medimos. Tú solo atiendes y cierras.
            </div>
            <div className="ovit-why2__bridgeActions">
              <a className="ovit-why2__btn" href="#planes">
                Ver planes
              </a>
              <a className="ovit-why2__btn ovit-why2__btn--ghost" href="#proceso">
                Ver proceso
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsContenidoAds;